@import 'styles/mixins';
@import 'styles/variables';

.leaveText {
  @include ui-md-text;

  color: $red-40;
  cursor: pointer;
}

.showPortal {
  margin-top: 6px;
}

.formRow {
  display: flex;
  justify-content: space-between;
  margin-bottom: 38px;

  header {
    @include ui-lg-bold;

    color: $gray-90;
    margin: 0 32px 8px 0;
  }
}

.explanation {
  @include body-sm-text;

  color: $gray-40;
  margin: 0;
}

.customizeLink {
  @include ui-lg-text;

  color: $green-50;

  &:hover {
    color: $green-60;
  }
}

.inputWithActions {
  position: relative;

  .inputActions {
    position: absolute;
    right: 1px;
    top: 11px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: var(--neutral-0);
  }

  button {
    padding: 15px 15px 9px 15px;
    border-left: 1px solid #dfe1e6;
  }
}

.divider {
  background: var(--dark-4);
  height: 1px;
  width: 100%;
  margin: 25px 0;
}

.workspaceNameHeading {
  margin-top: 30px;
}

.section {
  padding-bottom: 10px;
}
